var parse = require('./lib/parse');

module.exports = function (config) {
    config = config || {};
    var UA = config.ua;
    var HOST = config.host;

    var isNode;
    try {
        var isBrowser = typeof window !== 'undefined'
        isNode = !isBrowser && (Object.prototype.toString.call(global.process) === '[object process]');
    } catch (e) {
        isNode = false
    }
    if (isNode) {
        if(!UA) {
            if(this && this.req && this.req.headers && this.req.headers['user-agent']) {
                UA = this.req.headers['user-agent']
            } else if(config.ctx && config.ctx.header && config.ctx.header['user-agent']){
                UA = config.ctx.header['user-agent']
            }
        }
        if(!UA) {
            throw Error('获取 UserAgent 失败')
        }
        if(!HOST) {
            if(this && this.req && this.req.headers && this.req.headers['host']) {
                HOST = this.req.headers['host']
            } else if(config.ctx && config.ctx.header && config.ctx.header['host']){
                HOST = config.ctx.header['host']
            }
        }
        if(!HOST) {
            throw Error('获取 Host 失败')
        }
    } else {
        UA = UA || window.navigator.userAgent || window.navigator.vendor || window.opera;
        HOST = HOST || window.location.host
    }

    return parse(UA, HOST, isNode)
};